// extracted by mini-css-extract-plugin
module.exports = {"sortCardContainer":"styles_sortCardContainer__1rdbr","cardFooter":"styles_cardFooter__raHlF","editIcon":"styles_editIcon__aDWUQ"};